@if ((incomeTaxEntity$ | async) && isOndernemer) {
  <snelstart-venture-fiscaal-feature-prive-ontrekkingen-auto></snelstart-venture-fiscaal-feature-prive-ontrekkingen-auto>
  <form [formGroup]="formgroups">
    <div formArrayName="onttrekkingOverig">
      @if (onttrekkingOverig.length > 0) {
        @for (item of onttrekkingOverig.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving onttrekking' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
                                            maxlength="250"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              [minValue]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijOnttrekkingOverig(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDeletePrOverig"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      }
      <snelstart-ui-button (click)="addRijOnttrekkingOverig()"
                           class="snelstart-ui-button pb-3"
                           icon="plus"
                           type="link">Andere onttrekkingen toevoegen
      </snelstart-ui-button>
    </div>


    <div formArrayName="stortingenOverig">
      @if (stortingenOverig.length > 0) {
        @for (item of stortingenOverig.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving storting' : ''"
                                            class="col-auto custom-input-250"
                                            formControlName="omschrijving"
                                            id="omschrijving"
                                            maxlength="250"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-number-form-control [decimals]="0"
                                              [label]="i === 0 ? 'Bedrag' : ''"
                                              [minValue]="0"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="bedrag"
                                              id="bedrag"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijStortingenOverig(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDeletePrOverig"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      }
      <snelstart-ui-button (click)="addRijStortingenOverig()" class="snelstart-ui-button pb-3"
                           icon="plus"
                           type="link">Storting toevoegen
      </snelstart-ui-button>
    </div>
  </form>
} @else {
  <p>Er zijn geen ondernemingen gevonden.</p>
}

<!--<div *ngIf="heeftOndernemingen()">-->
<!--  <form (change)="saveForm()" [formGroup]="ondernemingFG">-->
<!--    <div formArrayName="ondernemingen">-->
<!--      <div *ngFor="let onderneming of ondernemingen.controls; let i = index "-->
<!--           [formGroupName]="i">-->


<!--        -->

<!--        -->
<!--        <div>-->
<!--          <div formArrayName="onttrekkingPriveGebruikWoning">-->
<!--            <div *ngFor="let onttrekkingWoning of getOnttrekkingPriveGebruikWoning(i).controls; let e = index "-->
<!--                 [formGroupName]="e">-->
<!--              <div class="row col-auto">-->
<!--                <div class="row col-auto" formGroupName="adresWoning">-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="e === 0 ? 'Postcode' : ''"-->
<!--                                                  class="col-auto custom-input-100"-->
<!--                                                  formControlName="postcode"-->
<!--                                                  id="postcodeWoning"-->
<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                  <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                    [decimals]="0"-->
<!--                                                    [label]="e === 0 ? 'Huisnr.' : ''"-->
<!--                                                    class="col-auto custom-input-75"-->
<!--                                                    formControlName="huisNummer"-->
<!--                                                    id="huisNummerWoning"-->
<!--                  >-->
<!--                  </snelstart-ui-number-form-control>-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="e === 0 ? 'Toev.' : ''"-->
<!--                                                  class="col-auto custom-input-75"-->
<!--                                                  formControlName="huisNummerToevoeging"-->
<!--                                                  id="huisNummerToevoegingWoning"-->
<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="e === 0 ? 'Woonplaats' : ''"-->
<!--                                                  class="col-auto custom-input-150"-->
<!--                                                  formControlName="woonplaats"-->
<!--                                                  id="woonplaatsWoning"-->

<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                </div>-->
<!--                <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                  [decimals]="0"-->
<!--                                                  [label]="e === 0 ? 'Woz-waarde' : ''"-->
<!--                                                  align="right"-->
<!--                                                  class="col-auto custom-input-150"-->
<!--                                                  formControlName="wozWaarde"-->
<!--                                                  prefix="€"-->

<!--                >-->
<!--                </snelstart-ui-number-form-control>-->
<!--                <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                  [label]="e === 0 ? '% eigendom' : ''"-->
<!--                                                  [showAllDecimals]="true"-->
<!--                                                  align="right"-->
<!--                                                  class="col-auto custom-input-100"-->
<!--                                                  formControlName="percentageGerechtigd"-->
<!--                                                  id="percentageGerechtigd"-->
<!--                                                  prefix="%"-->
<!--                >-->
<!--                </snelstart-ui-number-form-control>-->
<!--                <div class="row col-auto" formGroupName="periodeBewoning">-->
<!--                  <snelstart-ui-date-form-control (change)="saveForm()"-->
<!--                                                  [label]="e === 0 ? 'Begindatum' : ''"-->
<!--                                                  class="col-auto custom-input-125"-->
<!--                                                  formControlName="begindatum"-->
<!--                                                  id="begindatumWoning"-->

<!--                  >-->
<!--                  </snelstart-ui-date-form-control>-->
<!--                  <snelstart-ui-date-form-control (change)="saveForm()"-->
<!--                                                  [label]="e === 0 ? 'Einddatum' : ''"-->
<!--                                                  class="col-auto custom-input-125"-->
<!--                                                  formControlName="einddatum"-->
<!--                                                  id="einddatumWoning"-->


<!--                  >-->
<!--                  </snelstart-ui-date-form-control>-->
<!--                </div>-->
<!--                <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                  [decimals]="0"-->
<!--                                                  [label]="e === 0 ? 'Bedrag bijtelling' : ''"-->
<!--                                                  align="right"-->
<!--                                                  class="col-auto custom-input-125"-->
<!--                                                  formControlName="berekendeOnttrekking"-->
<!--                                                  id="berekendeOnttrekking"-->
<!--                                                  prefix="€"-->

<!--                >-->
<!--                </snelstart-ui-number-form-control>-->
<!--                <snelstart-ui-button (click)="deleteOnttrekkingPriveGebruikWoning(i, e)"-->
<!--                                     [class]="e === 0 ? 'firstrowbutton col-auto' : 'col-auto'"-->
<!--                                     icon="trash"-->
<!--                                     iconType="light"-->
<!--                                     id="buttonDeletePrgebrWoning"-->
<!--                                     size="medium"-->
<!--                                     type="secondary"-->
<!--                >-->
<!--                </snelstart-ui-button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div>-->
<!--            <div *ngIf="getOnttrekkingPriveGebruikWoning(i).length === 0">-->
<!--              <snelstart-ui-button (click)="addOnttrekkingPriveGebruikWoning(i)"-->
<!--                                   class="snelstart-ui-button pb-3" icon="plus"-->
<!--                                   type="link">Onttrekking priv&eacute;gebruik woning invullen-->
<!--              </snelstart-ui-button>-->
<!--            </div>-->
<!--            <div *ngIf="getOnttrekkingPriveGebruikWoning(i).length > 0">-->
<!--              <snelstart-ui-button (click)="addOnttrekkingPriveGebruikWoning(i)"-->
<!--                                   class="snelstart-ui-button pb-3" icon="plus"-->
<!--                                   type="link">Onttrekking priv&eacute;gebruik woning toevoegen-->
<!--              </snelstart-ui-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div>-->
<!--          <div formArrayName="onttrekkingOG">-->
<!--            <div-->
<!--              *ngFor="let onttrekkingOG of getOnttrekkingenOG(i).controls; let c = index "-->
<!--              [formGroupName]="c">-->
<!--              <div class="row">-->
<!--                <div class="row col-auto" formGroupName="adresOnroerendeZaak">-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="c === 0 ? 'Postcode' : ''"-->
<!--                                                  class="col-auto custom-input-100"-->
<!--                                                  formControlName="postcode"-->
<!--                                                  id="postcode"-->
<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                  <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                    [decimals]="0"-->
<!--                                                    [label]="c === 0 ? 'Huisnr.' : ''"-->
<!--                                                    class="col-auto custom-input-75"-->
<!--                                                    formControlName="huisNummer"-->
<!--                                                    id="huisNummer"-->

<!--                  >-->
<!--                  </snelstart-ui-number-form-control>-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="c === 0 ? 'Toev.' : ''"-->
<!--                                                  class="col-auto custom-input-75"-->
<!--                                                  formControlName="huisNummerToevoeging"-->
<!--                                                  id="huisNummerToevoeging"-->

<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="c === 0 ? 'Woonplaats' : ''"-->
<!--                                                  class="col-auto custom-input-150"-->
<!--                                                  formControlName="woonplaats"-->
<!--                                                  id="woonplaats"-->

<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                </div>-->
<!--                <snelstart-ui-number-form-control-->
<!--                  (change)="saveForm()"-->
<!--                  [decimals]="0"-->
<!--                  [label]="c === 0 ? 'Boekwaarde' : ''"-->
<!--                  align="right"-->
<!--                  class="col-auto custom-input-150"-->
<!--                  formControlName="boekwaardeOpMonentOnttrekking"-->
<!--                  prefix="€"-->

<!--                >-->
<!--                </snelstart-ui-number-form-control>-->
<!--                <snelstart-ui-select-form-control-->
<!--                  (change)="saveForm()"-->
<!--                  [label]="c === 0 ? 'Transactie met 3e?' : ''"-->
<!--                  [options]="optionsJaNee"-->
<!--                  class="col-auto custom-input-150"-->
<!--                  formControlName="transactieMetDerde"-->
<!--                  id="transactieMetDerde"-->

<!--                >-->
<!--                </snelstart-ui-select-form-control>-->
<!--                <snelstart-ui-select-form-control-->
<!--                  (change)="saveForm()"-->
<!--                  [label]="c === 0 ? 'Taxateur?' : ''"-->
<!--                  [options]="optionsJaNee"-->
<!--                  class="col-auto custom-input-100"-->
<!--                  formControlName="taxateurBetrokken"-->
<!--                  id="taxateurBetrokken"-->

<!--                >-->
<!--                </snelstart-ui-select-form-control>-->
<!--                <snelstart-ui-text-form-control *ngIf="onttrekkingOG.value.taxateurBetrokken"-->
<!--                                                [label]="c === 0 ? 'Naam taxateur' : ''"-->
<!--                                                class="col-auto custom-input-150"-->
<!--                                                formControlName="naamTaxateur"-->
<!--                                                id="naamTaxateur"-->
<!--                >-->
<!--                </snelstart-ui-text-form-control>-->
<!--                <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                  [decimals]="0"-->
<!--                                                  [label]="c === 0 ? 'Bedrag' : ''"-->
<!--                                                  align="right"-->
<!--                                                  class="col-auto custom-input-125"-->
<!--                                                  formControlName="waardeEconomischeVerkeer"-->
<!--                                                  prefix="€"-->

<!--                >-->
<!--                </snelstart-ui-number-form-control>-->
<!--                <snelstart-ui-button (click)="deleteOnttrekkingenOG(i, c)"-->
<!--                                     [class]="c === 0 ? 'firstrowbutton col-auto' : 'col-auto'"-->
<!--                                     icon="trash"-->
<!--                                     icon="trash"-->
<!--                                     id="buttonDeleteInv"-->
<!--                                     size="medium"-->
<!--                                     type="secondary"-->
<!--                >-->
<!--                </snelstart-ui-button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div>-->
<!--            <div *ngIf="getOnttrekkingenOG(i).length === 0">-->
<!--              <snelstart-ui-button (click)="addOnttrekkingenOG(i)" class="snelstart-ui-button pb-3"-->
<!--                                   icon="plus"-->
<!--                                   type="link">Onttrekkking onroerende zaak-->
<!--                invullen-->
<!--              </snelstart-ui-button>-->
<!--            </div>-->
<!--            <div *ngIf="getOnttrekkingenOG(i).length > 0">-->
<!--              <snelstart-ui-button (click)="addOnttrekkingenOG(i)" class="snelstart-ui-button pb-3"-->
<!--                                   icon="plus"-->
<!--                                   type="link">Onttrekkking onroerende zaak-->
<!--                toevoegen-->
<!--              </snelstart-ui-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div>-->
<!--          <div formArrayName="stortingOG">-->
<!--            <div-->
<!--              *ngFor="let stortingOG of getStortingenOG(i).controls; let g = index "-->
<!--              [formGroupName]="g">-->
<!--              <div class="row">-->
<!--                <div class="row col-auto" formGroupName="adresOnroerendeZaak">-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="g === 0 ? 'Postcode' : ''"-->
<!--                                                  class="col-auto custom-input-100"-->
<!--                                                  formControlName="postcode"-->
<!--                                                  id="postcodeSt"-->
<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                  <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                    [decimals]="0"-->
<!--                                                    [label]="g === 0 ? 'Huisnr.' : ''"-->
<!--                                                    class="col-auto custom-input-75"-->
<!--                                                    formControlName="huisNummer"-->
<!--                                                    id="huisNummerSt"-->
<!--                  >-->
<!--                  </snelstart-ui-number-form-control>-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="g === 0 ? 'Toev.' : ''"-->
<!--                                                  class="col-auto custom-input-75"-->
<!--                                                  formControlName="huisNummerToevoeging"-->
<!--                                                  id="huisNummerToevoegingSt"-->
<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                  <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                  [label]="g === 0 ? 'Woonplaats' : ''"-->
<!--                                                  class="col-auto custom-input-150"-->
<!--                                                  formControlName="woonplaats"-->
<!--                                                  id="woonplaatsSt"-->

<!--                  >-->
<!--                  </snelstart-ui-text-form-control>-->
<!--                </div>-->
<!--                <snelstart-ui-number-form-control (change)="saveForm()"-->
<!--                                                  [decimals]="0"-->
<!--                                                  [label]="g === 0 ? 'Bedrag' : ''"-->
<!--                                                  align="right"-->
<!--                                                  class="col-auto custom-input-150"-->
<!--                                                  formControlName="waardeEconomischeVerkeer"-->
<!--                                                  id="waardeEconomischeVerkeer"-->
<!--                                                  prefix="€"-->

<!--                >-->
<!--                </snelstart-ui-number-form-control>-->
<!--                <snelstart-ui-select-form-control-->
<!--                  (change)="saveForm()"-->
<!--                  [label]="g === 0 ? 'Taxateur?' : ''"-->
<!--                  [options]="optionsJaNee"-->
<!--                  class="col-auto custom-input-100"-->
<!--                  formControlName="taxateurBetrokken"-->
<!--                  id="taxateurBetrokkenSt"-->
<!--                >-->
<!--                </snelstart-ui-select-form-control>-->
<!--                <snelstart-ui-text-form-control (change)="saveForm()"-->
<!--                                                *ngIf="stortingOG.value.taxateurBetrokken"-->
<!--                                                [label]="g === 0 ? 'Naam taxateur' : ''"-->
<!--                                                class="col-auto custom-input-150"-->
<!--                                                formControlName="naamTaxateur"-->
<!--                                                id="naamTaxateurSt"-->
<!--                >-->
<!--                </snelstart-ui-text-form-control>-->
<!--                <snelstart-ui-button (click)="deleteStortingOG(i, g)"-->
<!--                                     [class]="g === 0 ? 'firstrowbutton col-auto' : 'col-auto'"-->
<!--                                     icon="trash"-->
<!--                                     iconType="light"-->
<!--                                     id="buttonDeleteSt"-->
<!--                                     size="medium"-->
<!--                                     type="secondary"-->
<!--                >-->
<!--                </snelstart-ui-button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div>-->
<!--            <div *ngIf="getStortingenOG(i).length === 0">-->
<!--              <snelstart-ui-button (click)="addStortingOG(i)" class="snelstart-ui-button pb-3" icon="plus"-->
<!--                                   type="link">Storting onroerende zaak invullen-->
<!--              </snelstart-ui-button>-->
<!--            </div>-->
<!--            <div *ngIf="getStortingenOG(i).length > 0">-->
<!--              <snelstart-ui-button (click)="addStortingOG(i)" class="snelstart-ui-button pb-3" icon="plus"-->
<!--                                   type="link">Storting onroerende zaak toevoegen-->
<!--              </snelstart-ui-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->
<!--  </form>-->

<!--</div>-->
